export default __webpack_public_path__ + "static/media/IconUserReturn.2420ca05.svg";